import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();



// WEBPACK FOOTER //
// ./src/rtep.js